import React, { Fragment, useEffect, useState } from 'react';
import SiteHeader from '../../../components/SiteHeader';
import { useParams, Link } from 'react-router-dom';
import Breadcumb from '../../../components/Breadcumb';
import FooterArea from '../../../components/FooterArea';
import Seo from '../../../components/Seo';
import { slugify } from '../../../utils/blog';
import { getBlogIndex } from '../../../utils/content';
import { breadcrumbSchema } from '../../../seo/config';
import breadcumb from '../../../images/breadcumb/blog.jpeg';
import PostCard from '../../../components/PostCard';
import '../../../components/BlogPost/style.scss';
import '../BlogFullWidth/style.scss';

const prettify = (slug) =>
    (slug || '').split('-').filter(Boolean).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

const BlogTag = () => {
    const { tag } = useParams();
    const [blogs, setBlogs] = useState([]);
    const [label, setLabel] = useState(prettify(tag));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getBlogIndex()
            .then((all) => {
                const tagged = all.filter((b) => (b.tags || []).some((t) => slugify(t) === tag));
                setBlogs(tagged);
                // Use the original tag label from a matching post if available.
                const match = tagged[0] && tagged[0].tags.find((t) => slugify(t) === tag);
                if (match) setLabel(match);
            })
            .finally(() => setLoading(false));
    }, [tag]);

    return (
        <Fragment>
            <Seo
                title={`${label} — Legal Articles & Insights`}
                description={`Read Legal Corridor's articles on ${label}. Expert legal insights and practical guidance from experienced advocates in Delhi.`}
                path={`/blog/tag/${tag}`}
                schema={[breadcrumbSchema([
                    { name: 'Home', path: '/' },
                    { name: 'Legal Insights', path: '/blogs' },
                    { name: label, path: `/blog/tag/${tag}` },
                ])]}
            />
            <SiteHeader />
            <main>
                <Breadcumb
                    className="breadcumbArea"
                    title={label}
                    breadcumbMenu={[
                        { name: 'Home', route: '/' },
                        { name: 'Legal Insights', route: '/blogs' },
                        { name: label },
                    ]}
                    background={breadcumb}
                />

                <section className="blogListing">
                    <div className="container">
                        <div className="blogIndex">
                            <p className="blogIndex__count">
                                {loading ? 'Loading articles…' : `${blogs.length} article${blogs.length === 1 ? '' : 's'} on ${label}`}
                                {' · '}<Link to="/blogs">All articles</Link>
                            </p>
                            {!loading && blogs.length === 0 ? (
                                <p className="blogIndex__empty">No articles found for “{label}”. <Link to="/blogs">Browse all articles</Link>.</p>
                            ) : (
                                <div className="blogIndex__grid">
                                    {blogs.map((blog) => (
                                        <PostCard key={blog.slug} post={blog} headingLevel="h2" />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </main>
            <FooterArea />
        </Fragment>
    );
};

export default BlogTag;
